import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import type { IDetailCellRendererParams } from "ag-grid-community";

import BagObjectDetail from "./DetailTabs/BagObjectDetail/BagObjectDetail";
import OrganizationsDetail from "./DetailTabs/OrganizationsDetail/OrganizationsDetail";
import LeaseDetail from "./DetailTabs/LeaseDetail/LeaseDetail";
import DocumentsDetail from "./DetailTabs/DocumentsDetail/DocumentsDetail";

export default function LeadDetailCell(
  params: IDetailCellRendererParams & { leadSearchId: string },
): React.JSX.Element {
  /**
   * A detailed view of a BAG object and its organizations.
   */
  const bagObject = params.data as IBagObject;

  const [documentCount, setDocumentCount] = React.useState<number>(0);

  const handleClick = (e: React.MouseEvent) => {
    /**
     * Make sure the rowNode stays focused when clicking in the detail view.
     */
    e.stopPropagation();
    const focusedCell = params.api.getFocusedCell();
    if (focusedCell) {
      params.api.setFocusedCell(focusedCell.rowIndex, "addressFormatted");
    }
  };

  return (
    <div onMouseDownCapture={handleClick} className="ag-detail-bag-object">
      <Tabs
        justify={true}
        transition={false}
        fill={true}
        defaultActiveKey={
          bagObject.organizations.length > 0 ? "organizations" : "object"
        }
      >
        <Tab eventKey="object" title="Object" className="p-3">
          <BagObjectDetail bagObject={bagObject} />
        </Tab>

        {bagObject.organizations.length > 0 && (
          <Tab
            eventKey="organizations"
            title={`Bedrijven actief (${bagObject.organizations.length})`}
            className="p-3"
          >
            <OrganizationsDetail organizations={bagObject.organizations} />
          </Tab>
        )}

        <Tab
          eventKey="contract"
          title={`Contract ${!bagObject.lease ? "(leeg)" : ""}`}
          className="p-3"
        >
          <LeaseDetail bagObject={bagObject} />
        </Tab>

        <Tab
          eventKey="documents"
          title={`Documenten${documentCount > 0 ? ` (${documentCount})` : ""}`}
          className="p-3"
        >
          <DocumentsDetail
            bagObjectId={bagObject.id}
            onCountChange={setDocumentCount}
          />
        </Tab>
      </Tabs>
    </div>
  );
}
